import { render, staticRenderFns } from "./index-shops.vue?vue&type=template&id=ba520816&scoped=true&"
import script from "./index-shops.vue?vue&type=script&lang=js&"
export * from "./index-shops.vue?vue&type=script&lang=js&"
import style0 from "./index-shops.vue?vue&type=style&index=0&id=ba520816&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba520816",
  null
  
)

export default component.exports